/* 
  src/actions/simpleAction.js
*/
export const simpleAction = () => dispatch => {
  dispatch({
    type: 'SIMPLE_ACTION',
    payload: 'result_of_simple_action'
  })
}



// WEBPACK FOOTER //
// ./src/actions/simpleAction.js